import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from '../../assests/Images/Logo-Blue.svg'
import axiosInstance from "../../api/axiosInstance";
import API_ENDPOINTS from "../../api/endpoints";
import { toast, ToastContainer } from 'react-toastify';
import { ThreeDots } from 'react-loader-spinner';


export default function Forget() {
    const [formData, setFormData] = useState({
        username: ''
    });
    const [loading, setLoading] = useState(false);
    const [confirmation, setConfiormation] = useState(false);


    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axiosInstance.get(`${API_ENDPOINTS.RESET}?account=${formData.username}`);
            setConfiormation(true)
        } catch (error) {
            console.error(error);
            const errorMessage = error.response?.data?.message || "An error occurred. Please try again.";
            toast.error(errorMessage);
            setFormData({
                username: ''
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
            {loading &&
                <ThreeDots
                    visible={true}
                    height="80"
                    width="80"
                    color="#1976d2"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass="dots-loading additional-class"
                />
            }
            <ToastContainer />
            <div className="w-full max-w-md bg-background/50 backdrop-blur border border-border p-6 ">
                <div className="flex flex-col items-center mb-8">
                    <div className="w-20 h-20 rounded-full flex items-center justify-center">
                        <img src={Logo} alt="Holecards Logo" className="h-18 w-18" />
                    </div>
                    <h1 className="text-white text-2xl font-semibold">Reset Password</h1>
                    <p className="text-gray-400">Enter your email or username to reset your password</p>
                </div>
                {!confirmation ? (
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="email" className="block text-sm font-bold text-white mb-2">
                                Email or Username
                            </label>
                            <input
                                type="text"
                                id="email"
                                name="username"
                                required
                                placeholder="Enter your email or username"
                                className="w-full px-4 py-2 bg-black text-white border border-border rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                onChange={handleChange}
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-secondary text-white py-2 rounded-md hover:opacity-75 transition-colors"
                        >
                            Reset Password
                        </button>
                    </form>
                ) :
                    (

                        <div className="flex flex-col items-center text-center">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-12 w-12 text-green-500"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
                            </span>
                            <h1 className="text-lg font-medium">Recovery Email Sent</h1>
                            <p className="text-gray-400 text-sm">If an account exists with the email or username you provided, we've sent instructions to reset your password.</p>
                            <Link to={'/'} className="px-3 py-3 mt-5 bg-secondary opacity-85 hover:opacity-100 ">Return to Login</Link>
                        </div>
                    )

                }


                <p className="text-center text-gray-400 text-sm mt-6">
                    Remember your password?{" "}
                    <Link to={'/'} className="text-blue-400 hover:underline">
                        Sign in
                    </Link>
                </p>
            </div>
        </div>
    );
}
